<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bi9"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('shipment_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button v-if="getLimit('shipment_add_button')" @click="funcAdd">
          新增
        </el-button>
        <el-button
          v-if="getLimit('shipment_checkQuire_button') && isAdmin"
          @click="funcheckQuire"
        >
          设置必填项
        </el-button>
        <el-button
          v-if="getLimit('shipment_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      class="mytable-style"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :cell-class-name="cellClassName"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="托运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="托运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          title="身份证到期日期"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.idCardDueRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxPoint"
          title="服务费率(%)"
          min-width="200"
          :visible="isCtms"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPointStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPointEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyClient"
          :formatter="formatterCommonStatus"
          title="是否月结"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyClient"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in commonStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="isIndependentCheckout"
          title="是否独立核算"
          min-width="130"
          :formatter="formatterCommonStatus"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isIndependentCheckout"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in commonStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="ensureFee"
          title="保证金基准(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.ensureFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.ensureFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="ensureFeeAmount"
          title="保证金余额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.ensureFeeAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.ensureFeeAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authTime"
          title="审核时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtAuthRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('shipment_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('shipment_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('shipment_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.authStatus == 3"
            class="item"
            effect="dark"
            content="创建虚拟账号"
            placement="top"
          >
            <vxe-button type="text" @click="funcDobiz(scope.row.code)">
              <i class="el-icon-connection" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getShipperList, delShipperInfo, syncMemName } from "@/api/shipment";
import { getRole } from "@/utils/getRole";
export default {
  name: "ShipmentManage",
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/shipment/exportShipment", //导出接口
        name: "个体托运人"
      },
      branch: this.$store.getters.branch,
      loading: false,
      isCtms: true, //非同城用户显示
      tableData: [],
      listQuery: {
        gmtCreatedRange: "",
        idCardDueRange: "",
        gmtAuthRange: "",
        staffType: "0", // 类型（托运人）
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        exportType: 1
      },
      sumObject: {
        freezingAmount: 0,
        amount: 0,
        ensureFeeAmount: 0
      },
      // 审核状态
      authStatusOptions: [
        { label: "未审核", value: 0, color: "gray" },
        // { label: "审核中", value: 1, color: "#0000ff" },
        { label: "审核驳回", value: 2, color: "#ff0000" },
        { label: "审核通过", value: 3, color: "#00bd93" }
      ],
      // 通用是否状态
      commonStatusOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 是否admin
      isAdmin: false
      // 是否顶级机构
      // isTopBranch: false
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    },
    "$store.state.tagsView.cachedViews": function(cachedViews) {
      if (!cachedViews.includes("ShipmentManage")) {
        let route = this.getRoute(this.$router.options.routes);
        route.meta.keepLive = false;
      }
    },
    "$route.query.needRefresh": function(newVal, oldVal) {
      // 新增调回需要刷新数据
      if (newVal) {
        this.$nextTick(() => {
          this.RefreshList();
          let newQuery = JSON.parse(JSON.stringify(this.$route.query));
          delete newQuery.needRefresh;
          this.$router.replace({ query: newQuery });
        });
      }
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.findList();
    let isCtmsShow = getRole();
    this.isCtms = !isCtmsShow;
    // let dataBranch = JSON.parse(localStorage.getItem('dataBranch'));
    // this.isTopBranch = dataBranch.level == 0;
  },
  methods: {
    getRoute(routerList) {
      var list = "";
      for (let item of routerList) {
        if (item.children) {
          let clist = this.getRoute(item.children);
          if (this.getRoute(item.children)) {
            return clist;
          }
        }
        if (item.name == "ShipmentManage") {
          list = item;
          return list;
        }
      }
      return list;
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getShipperList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 添加
    funcAdd() {
      this.$router.push({
        path: "/basicInfo/shipment/addShipmentForm"
      });
    },
    // 编辑
    funcEdit(row) {
      this.$router.push({
        path: "/basicInfo/shipment/editShipmentForm",
        query: {
          code: row.code,
          partyCode: row.partyCode,
          branchCode: row.branchCode
        }
      });
    },
    // 设置必填项
    funcheckQuire(row) {
      this.$router.push({
        path: "/basicInfo/shipment/requiredShipmentForm",
        query: { checkQuire: true }
      });
    },
    //详情
    funcDetail(row) {
      this.$router.push({
        path: "/basicInfo/shipment/infoShipmentForm",
        query: {
          code: row.code,
          partyCode: row.partyCode,
          branchCode: row.branchCode
        }
      });
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delShipperInfo({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 创建虚拟账号方法
    funcDobiz(codes) {
      this.$confirm("确认需要创建光大虚拟账号吗？")
        .then(_ => {
          syncMemName({ code: codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译通用是否状态
    formatterCommonStatus({ cellValue }) {
      const item = this.commonStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    //提示标红
    cellClassName({ row, rowIndex, column, columnIndex }) {
      //身份证
      if (column.property === "idCardDueDate") {
        if (row.idcardDueWarn == 1) {
          return "col-red";
        }
      }
    },
    // 合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "amount") {
            return this.$XEUtils.sum(data, column.property);
          }
          /*          if (column.property === "ensureFee") {
              return "待定";
            }*/
          if (column.property === "ensureFeeAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>
